(() => {
  const SAFE_REL_TOKENS = ['noopener', 'noreferrer'];

  const isExternalHttpLink = (anchor) => {
    try {
      const destination = new URL(anchor.getAttribute('href'), window.location.href);
      return ['http:', 'https:'].includes(destination.protocol)
        && destination.origin !== window.location.origin;
    } catch (_error) {
      return false;
    }
  };

  const enhance = (anchor) => {
    if (!anchor || !isExternalHttpLink(anchor)) return false;

    let changed = false;

    if (anchor.getAttribute('target') !== '_blank') {
      anchor.setAttribute('target', '_blank');
      changed = true;
    }

    const relTokens = new Set((anchor.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    SAFE_REL_TOKENS.forEach((token) => relTokens.add(token));
    const nextRel = Array.from(relTokens).join(' ');

    if (anchor.getAttribute('rel') !== nextRel) {
      anchor.setAttribute('rel', nextRel);
      changed = true;
    }

    return changed;
  };

  const enhanceWithin = (root) => {
    if (!root) return;
    if (root.matches?.('a[href]')) enhance(root);
    root.querySelectorAll?.('a[href]').forEach(enhance);
  };

  enhanceWithin(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        enhance(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(enhanceWithin);
    });
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['href', 'target', 'rel']
  });

  window.KohinoorExternalLinks = { enhance, enhanceWithin, isExternalHttpLink };
})();
